module.exports = {
      id: "comm-finance-usage",
      viewBox: "0 0 245.601 29.882",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-finance",
      toString: function () {
        return this.url;
      }
    }